<div class="opening-hour-row">
  <div class="day-label">
    <span>{{ label ?? formatDay(day) }}</span>
  </div>

  <gymfinder-opening-time-editor
    [editMode]="editMode"
    [showNotAvailable]="true"
    [value]="editorValue"
    (valueChange)="onEditorValueChange($event)">
  </gymfinder-opening-time-editor>
</div>
